// N.B For onboarding, we always want to show the cover page for these modules so that customers know what is coming up.
export const MODULES_WITH_COVER_FALLBACKS = [
  "CRITICAL_ROLE",
  "ORIGINAL_CONTRIBUTION",
  "EXPERT_LETTERS",
] as const;
